module.exports = __webpack_public_path__ + "img/20190902102522.7421b5c9.png";